import type { SpiffProcessInstanceRow } from "@/api/dto/process-instance";

/**
 * process instance metadata の値を文字列として取り出す。
 * backend は文字列で返すが、数値で来ても壊れないようにしておく。
 * 未設定・空文字は null に寄せる（呼び出し側で ?? を使えるように）。
 */
export function metadataOf(
  row: SpiffProcessInstanceRow,
  key: string,
): string | null {
  const value = row[key];

  if (value === null || value === undefined) return null;
  if (typeof value === "string") return value === "" ? null : value;
  if (typeof value === "number" || typeof value === "boolean")
    return String(value);

  return null;
}
